const FaceIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#ff9100"
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H57.08A6.919 6.919 0 0 1 64 6.919V57.08A6.919 6.919 0 0 1 57.081 64H6.92A6.919 6.919 0 0 1 0 57.081V6.92Z"
    />
    <path
      fill="#fff"
      fillOpacity={0.9}
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H57.08A6.919 6.919 0 0 1 64 6.919V57.08A6.919 6.919 0 0 1 57.081 64H6.92A6.919 6.919 0 0 1 0 57.081V6.92Z"
    />
    <path
      fill="#ff9100"
      fillRule="evenodd"
      d="M25.417 21.167a1.667 1.667 0 1 0-3.334 0 1.667 1.667 0 0 0 3.334 0Zm16.666 0a1.667 1.667 0 1 0-3.333 0 1.667 1.667 0 0 0 3.333 0Zm1.51 15 1.898 1.627A18.291 18.291 0 0 1 31.567 44.2c-5.2 0-10.05-2.18-13.496-5.925l-.238-.263 1.872-1.657a15.791 15.791 0 0 0 11.862 5.345 15.79 15.79 0 0 0 11.8-5.275l.227-.26Zm-5.915-7.739L32.523 19.5h-2.94l5.155 8.928-5.155 8.93h2.94l5.155-8.93Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillOpacity={0.4}
      fillRule="evenodd"
      d="M25.417 21.167a1.667 1.667 0 1 0-3.334 0 1.667 1.667 0 0 0 3.334 0Zm16.666 0a1.667 1.667 0 1 0-3.333 0 1.667 1.667 0 0 0 3.333 0Zm1.51 15 1.898 1.627A18.291 18.291 0 0 1 31.567 44.2c-5.2 0-10.05-2.18-13.496-5.925l-.238-.263 1.872-1.657a15.791 15.791 0 0 0 11.862 5.345 15.79 15.79 0 0 0 11.8-5.275l.227-.26Zm-5.915-7.739L32.523 19.5h-2.94l5.155 8.928-5.155 8.93h2.94l5.155-8.93Z"
      clipRule="evenodd"
    />
  </svg>
);
export default FaceIcon;
